/*
 * Public API Surface of voice-lib
 */
export * from './lib/component/voice-editor/voice-editor.component';
export * from './lib/component/voice-mobile-preview/voice-mobile-preview.component';
export * from './lib/component/voice-modal-detail/voice-modal-detail.component';
export * from './lib/component/voice-timeline-content/voice-timeline-content.component';
export * from './lib/component/voice-tpl-audit/voice-tpl-audit.component';
export * from './lib/component/voice-tpl-auto-match/voice-tpl-auto-match.component';
export * from './lib/component/voice-tpl-detail/voice-tpl-detail.component';
export * from './lib/component/voice-tpl-edit/voice-tpl-edit.component';

// 发送详情
export * from './lib/component/voice-sendDetail/voice.component';

// 接收记录
export * from './lib/component/voice-comment/voice.component';

//渠道管理
export * from './lib/component/voice-channel/view/view.component';
export * from './lib/component/voice-channel/edit/edit.component';

export * from "./lib/component/voice-sendconstraint-keyword/edit/edit.component";
export * from "./lib/component/voice-sendconstraint-keyword/import-export/import-export.component";
export * from "./lib/component/voice-sendconstraint-keyword/voice.component";

export * from './lib/voice-lib.module';
